"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFileNumber = exports.getGiveawayAssets = void 0;
const getGiveawayAssets = (giveawayResponse, section) => {
    return (giveawayResponse.assets
        ?.filter(asset => asset.metadata?.section === section)
        .sort((a, b) => (0, exports.extractFileNumber)(a.url) - (0, exports.extractFileNumber)(b.url))
        .map(asset => asset.url) || []);
};
exports.getGiveawayAssets = getGiveawayAssets;
const extractFileNumber = (filePath) => {
    const matches = filePath.match(/.*\/([0-9]+).jpg$/);
    if (!matches || matches.length === 0) {
        return 0;
    }
    const filename = matches.pop();
    return filename ? +filename : 0;
};
exports.extractFileNumber = extractFileNumber;
